/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Action, HStack } from '@doveit/bricks';
import { Aggregator } from '../../../../domain/types';
import { Property, PublishedOn } from '../../../../providers/api/dtos';
import ManagePublishedOnsAction, { ManagePublishedOnsActionProps } from '../manage-published-ons-action/ManagePublishedOnsAction';
import PublishedOnPreview from '../../../../published-on/components/published-on-preview/PublishedOnPreview';

interface BasePublishedOnListProps {
  canViewError?: boolean,
  canViewPublishedAt?: boolean,
  canVisit?: boolean,
  canViewPromotion?: boolean,
  canEditPromotion?: boolean,
  onEditSingle?: (publishedOn: PublishedOn) => void,
}

export type PublishedOnListProps = BasePublishedOnListProps & ({
  property: Partial<Pick<Property, 'publishedOn' | 'status'>>,
  showEditAction?: undefined,
  onEdit?: undefined,
} | {
  property: Property,
  showEditAction: boolean,
  onEdit?: ManagePublishedOnsActionProps['onSuccess'],
});

const PublishedOnList: React.FC<PublishedOnListProps> = ({
  property,
  showEditAction,
  canViewError = false,
  canViewPublishedAt = false,
  canVisit = false,
  canViewPromotion = false,
  canEditPromotion = false,
  onEdit,
  onEditSingle,
}) => (
  <div aria-label="Lista degli aggregatori su cui è pubblicato l'immobile">
    <HStack>
      <HStack>
        {Object.values(Aggregator)
          .sort((a, b) => ((a < b) ? -1 : 1))
          .map((agg) => {
            const publishedOn = property.publishedOn?.find((a) => a.aggregator === agg);

            return (
              <PublishedOnPreview
                key={agg}
                property={property}
                aggregator={agg}
                publishedOn={publishedOn}
                canViewError={canViewError}
                canViewPromotion={canViewPromotion}
                canViewPublishedAt={canViewPublishedAt}
                canVisit={canVisit}
                canEditPromotion={canEditPromotion}
                onEdit={onEditSingle}
                size={20}
              />
            );
          })}
      </HStack>
      {showEditAction && (
        <ManagePublishedOnsAction
          property={property}
          onSuccess={onEdit}
        >
          {({ openPublishedOnsModal }) => (
            <Action
              aria-label="Gestisci le pubblicazioni dell'immobile"
              title="Gestisci le pubblicazioni dell'immobile"
              label="Modifica"
              onClick={openPublishedOnsModal}
              size="S"
            />
          )}
        </ManagePublishedOnsAction>
      )}
    </HStack>
  </div>
);

export default PublishedOnList;
